import React, { Component, Fragment } from 'react';
import _ from 'lodash';

import N from '@common/constraints/numbers.contraints';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

class NumbersOnly extends Component {
  handleChange(evt) {
    let rawValue = this.props.value;

    if (!evt.target.value || evt.target.validity.valid) {
      rawValue = evt.target.value;
    }

    this.props.onChange && this.props.onChange(rawValue);
  }

  handleBlur(evt) {
    let rawValue = this.props.value;

    if (!evt.target.value || evt.target.validity.valid) {
      rawValue = evt.target.value;
    }

    this.props.onBlur && this.props.onBlur(rawValue);
  }

  get maxLength() {
    const { numberType, max, min } = this.props;
    if (max) return max.toString().length;
    switch (numberType) {
      case 'long':
        return N.MAX_LONG.toString().length;
      case 'short':
        return N.MAX_SHORT.toString().length;
      default:
        return N.MAX_INTEGER.toString().length;
    }
  }

  render() {
    const { negative, max, min, name, tooltip, onKeyDown, allowseparator } = this.props;
    let fieldProps = _.cloneDeep({
      ...this.props,
      allowseparator: allowseparator ? 'true' : 'false' 
    });
    delete fieldProps.max;
    delete fieldProps.min;
    delete fieldProps.negative;
    delete fieldProps.numberType;
    delete fieldProps.allowNegative;

    return (
      <Fragment>
        {tooltip && (
          <OverlayTrigger
            key={`top-${name}`}
            placement={'top'}
            overlay={
              <Tooltip id={`tooltip-${name}`}>
                <div className={'fontTooltip'}>{tooltip}</div>
              </Tooltip>
            }
          >
            <div>
              <input
                type="text"
                maxLength={this.maxLength}
                className="form-control"
                pattern={allowseparator ? (negative ? '^[-][0-9;]*' : '[0-9;]*') : (negative ? '^[-][0-9]*' : '[0-9]*')}
                {...fieldProps}
                value={this.props.value === undefined ? '' : this.props.value}
                onChange={this.handleChange.bind(this)}
                onBlur={this.handleBlur.bind(this)}
                onKeyDown={onKeyDown}
              />
            </div>
          </OverlayTrigger>
        )}
        {!tooltip && (
          <input
            type="text"
            maxLength={this.maxLength}
            className="form-control"
            pattern={allowseparator ? (negative ? '^[-][0-9;]*' : '[0-9;]*') : (negative ? '^[-][0-9]*' : '[0-9]*')}
            {...fieldProps}
            value={this.props.value === undefined ? '' : this.props.value}
            onChange={this.handleChange.bind(this)}
            onBlur={this.handleBlur.bind(this)}
            onKeyDown={onKeyDown}
          />
        )}
      </Fragment>
    );
  }
}

export default NumbersOnly;
